import View from 'mixins/view';
import MainDayView from 'ui/matchCalendar/event/main-day-view';
import MainDayBannerView from 'ui/matchCalendar/event/main-day-banner-view';
import OtherDaysView from 'ui/matchCalendar/event/other-days-view';
import controller from 'ui/matchCalendar/match-calendar-controller';

const elements = {
  container: '.match-wrapper',
  mainDay: '.c-calendar-main-dayly_match_main',
  otherDaysContainer: '.c-calendar-other-days-container',
};

export default class extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
    model.addEventListener('changedDay', this.render.bind(this));
  }
  render() {
    controller.getCurrentDayModel().then((data) => {
      const currentDayModel = this.model.getCurrentDay();
      const matches = currentDayModel.get('matches');
      const firstMatch = matches[0];

      /**
       * @TODO - disabled live mode, instead turned in match-bar
       *
       * if (firstMatch.get('isLive')) {
       *   controller.registerLiveUpdate(this.model.get('currentDay'));
       * }
      */

      const mainDayView = new MainDayView(firstMatch);
      mainDayView.render();
      this.addChild(mainDayView);

      const mainDayBannerView = new MainDayBannerView(firstMatch);
      if (firstMatch.get('banner')) {
        mainDayBannerView.render();
      } else {
        mainDayBannerView.hide();
      }
      this.addChild(mainDayBannerView);

      const otherDaysView = new OtherDaysView(currentDayModel);

      if (matches.length - 1) {
        otherDaysView.render();
      } else {
        otherDaysView.hide();
      }
      this.addChild(otherDaysView);
    });
  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/match-wrapper-view.js